import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { watchSteps } from "@/mocks/forecast";

export default function WatchGuide() {
  return (
    <section className="bg-secondary-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          align="center"
          eyebrow="蹲守指南"
          title="一条前瞻是怎么被整理出来的"
          description="我们不做情绪转述，只做三件事：捕捉信号、串联时间线、给出预警。这样你看到的每一条判断，都能自己复盘。"
        />

        <div className="relative mt-12 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {watchSteps.map((step, index) => (
            <Reveal key={step.title} delay={index * 100}>
              <div className="flex h-full flex-col rounded-lg border border-secondary-200 bg-background-50 p-6 md:p-7">
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-100 text-2xl text-secondary-800">
                    <i className={step.icon} />
                  </span>
                  <span className="font-heading text-3xl font-black text-secondary-200">0{index + 1}</span>
                </div>
                <h3 className="mt-6 font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}